var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSpaceTg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 148,
  height: 90,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.2,
  fillRule: "evenodd",
  d: "M10.174 36.8Q69.767 10.838 89.65 2.568c37.846-15.741 45.71-18.476 50.836-18.566 1.127-.02 3.648.26 5.281 1.584 1.378 1.119 1.758 2.63 1.939 3.69s.408 3.478.228 5.366c-2.051 21.549-10.925 73.843-15.44 97.978-1.91 10.213-5.672 13.637-9.313 13.972-7.914.728-13.924-5.23-21.589-10.255-11.994-7.862-18.77-12.757-30.413-20.43-13.455-8.866-4.733-13.74 2.935-21.703 2.007-2.085 36.876-33.801 37.551-36.678.085-.36.163-1.701-.634-2.41-.797-.708-1.973-.466-2.821-.273q-1.805.41-57.484 37.994-8.158 5.602-14.779 5.46c-4.866-.106-14.226-2.752-21.184-5.014C6.228 50.508-.555 49.042.036 44.33q.462-3.681 10.138-7.53",
  clipRule: "evenodd"
})));
export default SvgSpaceTg;